<template>
  <div class="c-l">
    <div class="c-l-t">
      <img style="margin-top: 50px" src="../assets/repert.png" alt="" />
      <div class="c-l-t-s clearfix">
        <span>{{ member.name }}</span>
        <!-- <img class="c-l-t-i" src="../assets/17.png" alt @click="onMemberTap" /> -->
      </div>
      <div class="c-l-t-g clearfix" :class="member.level == 0 ? 'c-l-t-d' : ''">
        <div class>{{ member.technical_title }}</div>
      </div>
      <div >
        <div class="c-l-t-t">{{ member.unit }}</div>
      </div>

      <div
        v-if="member.level == 0"
        class="c-l-t-b"
        style="margin-top: 28px"
        @click="onApplyTap"
      >
        申请成为会员
      </div>
    </div>
    <div class="c-l-b">
      <div
        v-for="(item, index) in navItem"
        v-bind:key="index"
        :class="{ active: index == code }"
        class="c-l-b-item"
        @click="gopath(item.name, item.val, index)"
      >
        <span>{{ item.val }}</span>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="dialog" v-if="isrenew == true">
        <h3 class="renewtimeout">证书有效期截止：</h3>
        <div class="renewtime">
          <p>2022年5月13日</p>
        </div>
        <p class="content">
          尊敬的会员单位:
          <br />为保障协会各项工作顺利开展，更好的为会员企业提供服务，根据我会《章程》和《贵州省建筑业协会会费收取及使用管理暂行办法》有关规定，请各会员单位按时交纳会费。
          <br />会员服务：0851-85360455&nbsp;&nbsp;&nbsp;财务部门：0851-85360453
          <br /><span class="fee-note">注：补缴往年会费请联系0851-85360455</span>
        </p>
        <div class="btn" @click="gorenew">
          <p>去续费</p>
        </div>
      </div>
      <div class="dialog" v-if="isrenew == false">
        <img
          style="width: 153px; height: 140px"
          src="../assets/faile.png"
          alt
        />
        <p style="color: #333333; font-size: 20px">证书有效期截止提醒</p>
        <p style="margin-top: 7px">请在证书有效期截止前完成续费</p>
        <div class="knowbtn" @click="know">
          <p>知道了</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisiblepay"
      width="30%"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <p style="font-size: 16px; color: #333333">请扫下方二维码完成缴费</p>
        <!-- <div id="qrCode" ref="qrCodeDiv" :style="{backgroundImage:'url('+wechat+')'}"></div> -->
        <div
          style="
            width: 100%;
            height: 200px;
            display: flex;
            justify-content: space-evenly;
          "
        >
          <div class="zhifu">
            <svg class="icon svg-icon" aria-hidden="true" v-html="wechat">
              <svg xmlns="http://www.w3.org/2000/svg" width="300" />
            </svg>
            <img
              style="width: 40px; height: 40px"
              src="../assets/weixin.png"
              alt
            />
          </div>
          <div class="zhifu">
            <svg class="icon svg-icon" aria-hidden="true" v-html="alipay">
              <svg xmlns="http://www.w3.org/2000/svg" width="300" />
            </svg>
            <img
              style="width: 40px; height: 40px"
              src="../assets/zhifubao.png"
              alt
            />
          </div>
          <use xlink:href="#icon-houcangguanlisvg"></use>
        </div>
        <!-- <div style="width:100%;display: flex;justify-content: space-evenly;transform: translateY(-40px);">
          <img style="width:40px;height:40px" src="../../assets/weixin.png" alt />
          <img style="width:40px;height:40px" src="../../assets/zhifubao.png" alt />
        </div>-->

        <el-button style="color: #194abe; width: 90%" @click="ispaye()"
          >已确定扫码成功</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { expertinfo } from "../utils/api.js";
import { Base64 } from "js-base64";
import {
  myOrder,
  Apply,
  ApplyInfo,
  renewOrder, //支付
} from "../utils/api.js";
export default {
  name: "Members",

  data() {
    return {
      isrenew: null,
      state_text: "会员单位",
      code: 0,
      member: {},
      info: {},
      dialogVisible: false,
      dialogVisiblepay: false,
      navItem: [
        {
            val: "待审核",
            name: "Awardlogreviewunchecked",
          },
          {
            val: "已审核",
            name: "Awardlogreviewchecked",
          }
      ],
      wechat: "", //微信支付二维码
      alipay: "",
      award_batch_id:0,
      award_id:0,
      bname:'',
      is_leader:0
    };
  },
  watch: {
    $route(to) {
      console.log('$route',to);
      this.syncRouteParams(to);
      this.cheght(to);
    },
  },
  async mounted() {
    
    console.log(this.$route);
    console.log('this.$route.fullPath.indexOf(',this.$route.fullPath.indexOf('Awardlogreview'))
    console.log('this.$route.fullPath.query',this.$route.query)
    if(this.$route.fullPath.indexOf('eresetpwd') != -1){
        this.navItem = [];
    } 
    this.syncRouteParams(this.$route);
    this.cheght(this.$route);
    this.getmember();
    this.initData();
  },

  methods: {
    syncRouteParams(route) {
      if (route.fullPath.indexOf('Awardlogreview') === -1) {
        return;
      }
      this.award_batch_id = route.query.award_batch_id;
      this.award_id = route.query.award_id;
      this.bname = route.query.bname;
      this.is_leader = route.query.is_leader;
    },
    async getmember() {
      let member = await expertinfo();
      console.log(987,member);
      // let info = await ApplyInfo();
      // this.info = info;
      this.member = member;
      console.log("ojbk", member);
      this.$forceUpdate();
    },
    async initData() {
      let info = await ApplyInfo();
      this.info = info;
    },
    async pay() {
      let that = this;
      renewOrder().then(
        (res) => {
          this.dialogVisiblepay = true;
          this.wechat = Base64.decode(res.wechat);
          this.alipay = Base64.decode(res.alipay);
          console.log(this.wechat);
          let timer = null;
          let timeout = 0;
          timer = setInterval(() => {
            timeout++;
            myOrder(res.order_id).then((res) => {
              if (res.pay_status == 1) {
                that.ispaye();
                that.dialogVisiblepay = false;
                clearInterval(timer);
                that.getmember();
                that.initData();
              }
            });
            if (timeout >= 30) {
              this.ispaye();
              clearInterval(timer);
              this.dialogVisiblepay = false;
              this.getmember();
              this.initData();
            }
            if (this.dialogVisible == false && this.dialogVisiblepay == false) {
              clearInterval(timer);
            }
          }, 1000);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    ispaye() {
      this.dialogVisiblepay = false;
      this.dialogVisible = false;
    },
    //打开支付弹框
    gorenew() {
      this.dialogVisiblepay = true;
      this.dialogVisible = false;
      this.initData();
      this.dialogVisiblepay = false;
      this.pay();
    },
    //知道了
    know() {
      this.dialogVisible = false;
      this.dialogVisiblepay = false;
    },
    //续费
    renew() {
      let that = this;
      this.dialogVisible = true;
      this.dialogVisiblepay = false;
      renewOrder().then(
        (res) => {
          this.isrenew = true;
          this.wechat = Base64.decode(res.wechat);
          this.alipay = Base64.decode(res.alipay);
        },
        (err) => {
          this.isrenew = false;
          console.log(err);
        }
      );
    },
    gopath(name, title, index) {
      this.code = parseInt(index);
      // let pathname='member/'+name;
      var query = {
          name:title
      }
      if(this.award_batch_id !== undefined && this.award_batch_id !== null && this.award_batch_id !== ''){
          query['award_batch_id'] = this.award_batch_id;
      }
      if(this.award_id !== undefined && this.award_id !== null && this.award_id !== ''){
          query['award_id'] = this.award_id;
      }
      if(this.bname !== undefined && this.bname !== null && this.bname !== ''){
          query['bname'] = this.bname;
      }
      if(this.is_leader !== undefined && this.is_leader !== null && this.is_leader !== ''){
          query['is_leader'] = this.is_leader;
      }
      this.$router.push({
        path: name,
        query:query,
      });
    },
    cheght(item) {
      const fjjrjk = this.navItem.findIndex((val) => {
        console.log(999, item.path, val.name);
        return item.path.indexOf(val.name) != -1;
      });
      this.code = parseInt(fjjrjk);
    },
    onApplyTap() {
      this.$router.push({
        path: "apply",
      });
    },
    // 跳转修改资料
    onMemberTap() {
      this.$router.push({
        path: "infor",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dialog {
  max-width: 454px;
  height: 318px;
  padding: 0 46px;
  box-sizing: border-box;
  text-align: center;
  margin: 0 auto;
}
.btn,
.knowbtn {
  cursor: pointer;
  margin: 0 auto;
  margin-top: 18px;
  max-width: 177px;
  height: 45px;
  background: #ffffff;
  border: 1px solid #194abe;
  opacity: 1;
  border-radius: 4px;
  p {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 45px;
    color: #194abe;
  }
}
.knowbtn {
  border: 1px solid #7c828a;
  margin-top: 43px;
  p {
    color: #7c828a;
  }
}
.renewtimeout {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #333333;
}
.content {
  margin-top: 16px;
  text-align: start;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  text-indent: 2em;
  color: #7c828a;
}
.fee-note {
  color: #e51725;
}
.renewtime {
  margin: 0 auto;
  max-width: 224px;
  height: 45px;
  background: #fff7e8;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  p {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 45px;
    color: #e51725;
  }
}
.c-l-t-i-m {
  width: 29px;
  height: 21px;
}

.c-l {
  float: left;

  &-t {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 280px;
    background: url("../assets/16.png");
    background-repeat: no-repart;
    background-size: cover;
    padding: 0 20px;
    box-sizing: border-box;

    &-a {
      width: 222px;
      height: 117px;
      margin-top: 30px;
    }

    &-s {
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      margin-top: 10px;
      width: 268px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: inline-block;
        max-width: 222px;
      }
    }

    &-g {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #194ABE;
      font-size: 16px;
      height: 24px;
      background: linear-gradient(270deg, #fff 0%, #fff 100%);
      opacity: 1;
      border-radius: 12px 0px 12px 0px;
      margin: 0 auto;
      margin-top: 10px;
      padding: 5px 10px;
    }

    &-d {
      background: #a4aab5 !important;
    }

    &-i {
      display: inline-block;
      float: left;
      cursor: pointer;
    }

    &-t {
      color: #ffffff;
      font-size: 16px;
      opacity: 0.8;
      margin-top: 10px;
    }

    &-b {
      // width: 76px;
      padding: 0px 10px;
      height: 38px;
      background: rgba(255, 255, 255, 0.18);
      border: 1px solid #ffffff;
      opacity: 1;
      line-height: 38px;
      margin: 0 auto;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }

  &-b {
    width: 268px;
    height: auto;
    background: #fff;
    border-radius: 6px;
    margin-top: 14px;
    padding-top: 14px;
    padding-bottom: 28px;

    &-item {
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: #7c828a;
      font-size: 18px;

      span {
        padding-bottom: 12px;
        border-bottom: 1px double #d4dbdd;
        cursor: pointer;
      }
    }
  }

  .active {
    background: url("../assets/linhe.png");
    background-repeat: no-repart;
    background-size: contain;
    border-left: 5px solid #194abe;
    color: #194abe;
    font-weight: bold;

    span {
      border: none;
    }
  }
}
</style>
